<div class="layout" [ngClass]="{'nav-open': isNavOpen}">
  <div class="panel-left">
    <navigation></navigation>
  </div>

  <main class="panel-right">
    <top-bar></top-bar>
    <router-outlet></router-outlet>
    <bottom-bar></bottom-bar>
  </main>
</div>
